/**
 * @generated SignedSource<<d23d103a42c8a1cebc354dc685d2918b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CommonProviderQuery$variables = Record<PropertyKey, never>;
export type CommonProviderQuery$data = {
  readonly system_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      };
    }>;
  };
};
export type CommonProviderQuery = {
  response: CommonProviderQuery$data;
  variables: CommonProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "systemConnection",
    "kind": "LinkedField",
    "name": "system_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "systemEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "system",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommonProviderQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CommonProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9fbab88a8852fb19a642d4731e45a1ac",
    "id": null,
    "metadata": {},
    "name": "CommonProviderQuery",
    "operationKind": "query",
    "text": "query CommonProviderQuery {\n  system_connection {\n    edges {\n      node {\n        id\n        key\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "04cb83c1018898519d12137f242e372b";

export default node;
